export default "__VITE_ASSET__7a71f736__"